export default "__VITE_ASSET__dfffa3db__"